import ApplicationController from "./application_controller";
import { get } from "@rails/request.js"
import TomSelect from "tom-select";

export default class extends ApplicationController {
    static targets = ["select"]
    static values = {
        url: String,
        param: String
    }

    connect() {
        if (this.selectTarget.id === "") {
            this.selectTarget.id = Math.random().toString(36)
        }
    }

    change(event) {
        let params = new URLSearchParams()


        // Check if the selectTarget is a TomSelect
        if (this.selectTarget.tomselect instanceof TomSelect) {
            // Use TomSelect's getValue method to get the selected value
            params.append(this.paramValue, this.selectTarget.tomselect.getValue())
        } else {
            params.append(this.paramValue, event.target.selectedOptions[0].value)
        }



        // keep an empty select option in the target select element
        // to prevent the select element from being disabled
        // when the target select element has no options
        if (params.get(this.paramValue) === "") {
            return
        } else {
            params.append("target", this.selectTarget.id)


        // when the select element has no options, load all records
        // by setting the param to an empty string
        //if (this.selectTarget.options.length === 0) {
        //    params.set(this.paramValue, "")
        //}

        get(`${this.urlValue}?${params}`, {
            responseKind: "turbo-stream",
            onSuccess: () => {
                // Turbo Stream updates the DOM automatically
                // If TomSelect is used, we need to reload options from the updated select
                if (this.selectTarget.tomselect instanceof TomSelect) {
                    // Clear and reload options from the updated select element
                    this.selectTarget.tomselect.clear()
                    this.selectTarget.tomselect.clearOptions()
                    
                    // Add all options from the select element to TomSelect
                    Array.from(this.selectTarget.options).forEach(option => {
                        if (option.value) {
                            this.selectTarget.tomselect.addOption({
                                value: option.value,
                                text: option.text
                            })
                        }
                    })
                    
                    // Refresh TomSelect to show new options
                    this.selectTarget.tomselect.refreshOptions(false)
                }
            }
        })
        }
    }

    reloadContacts() {
        // Finde das Customer-Select Element
        const customerSelect = this.element.querySelector('select[name*="customer_id"]')
        if (!customerSelect) return

        // Hole den aktuell ausgewählten Customer
        let customerId = ""
        if (customerSelect.tomselect instanceof TomSelect) {
            customerId = customerSelect.tomselect.getValue()
        } else {
            customerId = customerSelect.value
        }

        if (customerId === "") {
            // Wenn kein Customer ausgewählt, lösche alle Kontakte
            this.clearContacts()
            return
        }

        // Lade Kontakte für den ausgewählten Customer
        let params = new URLSearchParams()
        params.append(this.paramValue, customerId)
        params.append("target", this.selectTarget.id)

        get(`${this.urlValue}?${params}`, {
            responseKind: "turbo-stream",
            onSuccess: () => {
                // Turbo Stream updates the DOM automatically
                // If TomSelect is used, we need to reload options from the updated select
                if (this.selectTarget.tomselect instanceof TomSelect) {
                    // Clear and reload options from the updated select element
                    this.selectTarget.tomselect.clear()
                    this.selectTarget.tomselect.clearOptions()
                    
                    // Add all options from the select element to TomSelect
                    Array.from(this.selectTarget.options).forEach(option => {
                        if (option.value) {
                            this.selectTarget.tomselect.addOption({
                                value: option.value,
                                text: option.text
                            })
                        }
                    })
                    
                    // Refresh TomSelect to show new options
                    this.selectTarget.tomselect.refreshOptions(false)
                }
            }
        })
    }

    clearContacts() {
        // Lösche alle Kontakte aus dem Select
        if (this.selectTarget.tomselect instanceof TomSelect) {
            this.selectTarget.tomselect.clear()
        } else {
            // Für normales Select: alle Optionen außer der ersten (leeren) entfernen
            while (this.selectTarget.options.length > 1) {
                this.selectTarget.removeChild(this.selectTarget.lastChild)
            }
        }
    }
}